export default "__VITE_ASSET__BND6WpSU__"